import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import flow from 'lodash/flow'
import ArticleCard from './ArticleCard'

class ArticleSummaryCard extends PureComponent {

    render() {
        const {article, variation='horizontal', ...rest} = this.props;

        const image = variation === 'vertical' ? article.vertical_hero : article.horizontal_hero ?
        {
            desktop: article.horizontal_hero.tablet ? article.horizontal_hero.tablet : article.horizontal_hero.desktop,
            blur: article.horizontal_hero.blur,
        } : null;

        const video = variation === 'vertical' ? article.vertical_video : article.video;

        return <ArticleCard article={article}
                                   size='small'
                                   showArticleTime={true}
                                   imageAspect={variation === 'vertical' ? 1.45 : variation === 'trending' ? 0.48 : 0.54}
                                   dataCy='articleSummaryCard'
                                   image={image}
                                   video={video}
                                   {...rest}/>
    }

}

export default flow([
    injectSheet( theme => ({

    }))
])(ArticleSummaryCard)





// WEBPACK FOOTER //
// ./src/components/Card/ArticleSummaryCard.js